import homeStockTitleArt from '../../assets/home-stock-title-1.png';

type LatestHomeStockTitleIconProps = {
  className?: string;
};

/** Tight crop around artwork so title decoration fits without clipping the header. */
const HOME_STOCK_TITLE_VIEWBOX = '24 48 464 440';

/**
 * Absolutely positioned inside AppPageTitleSection — must not affect section height.
 * Sits to the left of the h-8 three-dot menu (2rem + 0.5rem gap).
 * bottom: 5px above section divider.
 */
export const LatestHomeStockTitleIcon = ({ className = '' }: LatestHomeStockTitleIconProps) => (
  <div
    className={[
      'pointer-events-none absolute bottom-[5px] right-[calc(2rem+0.5rem)] z-0 h-[5rem] w-[5rem]',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    aria-hidden
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={HOME_STOCK_TITLE_VIEWBOX}
      preserveAspectRatio="xMaxYMax meet"
      className="block h-full w-full"
    >
      <image href={homeStockTitleArt} width="512" height="512" />
    </svg>
  </div>
);
